(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dp24-motif-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp24-motif-finder')) {
    class Dp24MotifFinder extends HTMLElement {
      connectedCallback() {
        this.state = { who: 'me', theme: null, tip: '' };
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.dots = [...this.querySelectorAll('.dp24-finder__progress span')];
        this.addEventListener('click', (e) => this.onClick(e));
      }

      onClick(e) {
        const t = e.target.closest('button');
        if (!t || !this.contains(t)) return;
        if (t.dataset.who) {
          this.state.who = t.dataset.who;
          this.dataset.who = t.dataset.who;
          this.go(2);
        } else if (t.dataset.theme) {
          this.state.theme = t.dataset.theme;
          if (t.dataset.theme === 'photo') this.showResult();
          else this.go(3);
        } else if (t.dataset.level) {
          this.state.tip = t.dataset.tip || '';
          this.showResult();
        } else if (t.hasAttribute('data-back')) {
          const current = this.steps.findIndex((s) => !s.hidden) + 1;
          this.go(Math.max(1, current - 1));
        } else if (t.hasAttribute('data-restart')) {
          this.state = { who: 'me', theme: null, tip: '' };
          this.dataset.who = 'me';
          this.go(1);
        }
      }

      showResult() {
        this.querySelectorAll('[data-result]').forEach((p) => {
          p.hidden = p.dataset.result !== this.state.theme;
          const tip = p.querySelector('[data-tip-target]');
          if (tip) {
            tip.textContent = this.state.tip;
            tip.hidden = !this.state.tip;
          }
        });
        this.go(4);
        try {
          window.Shopify?.analytics?.publish?.('dp24_motif_finder', { who: this.state.who, theme: this.state.theme });
        } catch (err) {}
      }

      go(n) {
        this.steps.forEach((s) => (s.hidden = Number(s.dataset.step) !== n));
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i < Math.min(n, 3)));
        const active = this.steps[n - 1];
        const focusEl = active.querySelector('[data-result]:not([hidden]) .dp24-finder__q') || active.querySelector('.dp24-finder__q');
        focusEl?.focus({ preventScroll: true });
        const top = this.getBoundingClientRect().top;
        if (top < 0 || top > window.innerHeight * 0.4) {
          this.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
    customElements.define('dp24-motif-finder', Dp24MotifFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp24-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp24-recently-viewed')) {
    class Dp24RecentlyViewed extends HTMLElement {
      connectedCallback() {
        const KEY = 'dp24-recent';
        const d = this.dataset;
        const exclude = new Set(
          (d.exclude || '')
            .split(',')
            .map((h) => h.trim())
            .filter(Boolean)
        );
        let list = [];
        try {
          list = JSON.parse(localStorage.getItem(KEY) || '[]');
        } catch (e) {}
        if (!Array.isArray(list)) list = [];
        list = list.filter((x) => x && x.h && !exclude.has(x.h));
        const limit = Number(d.limit) || 4;
        const current = d.current || d.handle;
        const others = list.filter((x) => x.h !== current).slice(0, limit);
        if (d.handle && !exclude.has(d.handle)) {
          const item = { h: d.handle, u: d.url, t: d.title, i: d.image, p: d.price, c: d.compare };
          list = [item, ...list.filter((x) => x.h !== d.handle)];
        }
        try {
          localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
        } catch (e) {}
        if (!others.length) return;
        const grid = this.querySelector('[data-grid]');
        others.forEach((x) => grid.append(this.card(x)));
        this.hidden = false;
      }

      card(x) {
        const a = document.createElement('a');
        a.className = 'dp24-mcard';
        a.href = x.u;
        const media = document.createElement('span');
        media.className = 'dp24-mcard__media';
        if (x.i) {
          const img = document.createElement('img');
          img.src = x.i;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 480;
          img.height = 480;
          media.append(img);
        }
        const title = document.createElement('span');
        title.className = 'dp24-mcard__title';
        title.textContent = (x.t || '').replace(/^Diamond Painting\s*[-–]\s*/, '');
        const price = document.createElement('span');
        price.className = 'dp24-mcard__price';
        const strong = document.createElement('strong');
        strong.textContent = x.p || '';
        price.append(strong);
        if (x.c) {
          const s = document.createElement('s');
          s.className = 'dp24-mcard__muted';
          s.textContent = ' ' + x.c;
          price.append(' ', s);
        }
        a.append(media, title, price);
        return a;
      }
    }
    customElements.define('dp24-recently-viewed', Dp24RecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp24-story-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dp24-story-bar')) {
    class Dp24StoryBar extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.ms = (Number(this.dataset.seconds) || 6) * 1000;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.seen = this.readSeen();
        this.querySelectorAll('[data-open]').forEach((b) => {
          if (this.seen.includes(b.dataset.key)) b.classList.add('is-seen');
          b.addEventListener('click', () => this.open(b.dataset.open, b));
        });
        this.dialog.addEventListener('click', (e) => this.onClick(e));
        this.dialog.addEventListener('close', () => this.onClose());
        this.dialog.addEventListener('pointerdown', (e) => this.onDown(e));
        this.dialog.addEventListener('pointerup', () => this.onUp());
        this.dialog.addEventListener('pointercancel', () => this.onUp());
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.next();
          if (e.key === 'ArrowLeft') this.prev();
        });
        document.addEventListener('visibilitychange', () => (document.hidden ? this.pause() : this.resume()));
      }

      readSeen() {
        try {
          return JSON.parse(sessionStorage.getItem('dp24-stories-seen') || '[]');
        } catch (e) {
          return [];
        }
      }

      markSeen(btn) {
        btn.classList.add('is-seen');
        if (this.seen.includes(btn.dataset.key)) return;
        this.seen.push(btn.dataset.key);
        try {
          sessionStorage.setItem('dp24-stories-seen', JSON.stringify(this.seen));
        } catch (e) {}
      }

      open(key, trigger) {
        this.trigger = trigger;
        this.sets = [...this.dialog.querySelectorAll('[data-story]')];
        this.showStory(Math.max(0, this.sets.findIndex((s) => s.dataset.story === key)));
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.dialog.querySelector('.dp24-story__set:not([hidden]) [data-close]')?.focus({ preventScroll: true });
        try {
          window.Shopify?.analytics?.publish?.('dp24_story_open', { collection: trigger.dataset.key });
        } catch (e) {}
      }

      showStory(storyIndex) {
        if (storyIndex >= this.sets.length) return this.dialog.close();
        this.storyIndex = storyIndex;
        this.sets.forEach((s, i) => (s.hidden = i !== storyIndex));
        this.set = this.sets[storyIndex];
        this.slides = [...this.set.querySelectorAll('[data-slide]')];
        this.bars = [...this.set.querySelectorAll('.dp24-story__bars i')];
        const btn = this.querySelector(`[data-open="${this.set.dataset.story}"]`);
        if (btn) this.markSeen(btn);
        this.showSlide(0);
      }

      showSlide(n) {
        this.slideIndex = n;
        this.slides.forEach((s, i) => (s.hidden = i !== n));
        this.bars.forEach((b, i) => {
          b.style.transition = 'none';
          b.style.width = i < n ? '100%' : '0%';
        });
        this.set.classList.toggle('is-first', n === 0);
        this.start();
      }

      start() {
        clearTimeout(this.timer);
        const last = this.slideIndex === this.slides.length - 1;
        const bar = this.bars[this.slideIndex];
        if (last || this.reduced) {
          if (bar) bar.style.width = last ? '100%' : '0%';
          return;
        }
        this.remaining = this.ms;
        this.run(bar);
      }

      run(bar) {
        this.startedAt = performance.now();
        const done = 1 - this.remaining / this.ms;
        bar.style.transition = 'none';
        bar.style.width = done * 100 + '%';
        void bar.offsetWidth;
        bar.style.transition = `width ${this.remaining}ms linear`;
        bar.style.width = '100%';
        this.timer = setTimeout(() => this.next(), this.remaining);
      }

      pause() {
        if (!this.dialog.open || !this.timer) return;
        clearTimeout(this.timer);
        this.timer = null;
        this.remaining = Math.max(0, this.remaining - (performance.now() - this.startedAt));
        const bar = this.bars[this.slideIndex];
        if (bar) {
          bar.style.width = getComputedStyle(bar).width;
          bar.style.transition = 'none';
        }
        this.paused = true;
      }

      resume() {
        if (!this.dialog.open || !this.paused) return;
        this.paused = false;
        const bar = this.bars[this.slideIndex];
        if (bar && this.remaining > 0) this.run(bar);
      }

      next() {
        if (this.slideIndex < this.slides.length - 1) this.showSlide(this.slideIndex + 1);
      }

      prev() {
        if (this.slideIndex > 0) this.showSlide(this.slideIndex - 1);
        else if (this.storyIndex > 0) this.showStory(this.storyIndex - 1);
      }

      onDown(e) {
        if (e.target.closest('a, button')) return;
        this.downAt = performance.now();
        this.holdTimer = setTimeout(() => this.pause(), 200);
      }

      onUp() {
        clearTimeout(this.holdTimer);
        if (this.paused) {
          this.wasHold = true;
          this.resume();
        }
      }

      onClick(e) {
        const t = e.target;
        if (t === this.dialog) return this.dialog.close();
        if (t.closest('[data-close]')) return this.dialog.close();
        if (t.closest('[data-next]')) return this.next();
        if (t.closest('[data-prev]')) return this.prev();
        if (t.closest('[data-restart]')) return this.showSlide(0);
        if (t.closest('a, button')) return;
        if (this.wasHold) {
          this.wasHold = false;
          return;
        }
        const rect = this.set.getBoundingClientRect();
        if (e.clientX - rect.left < rect.width / 3) this.prev();
        else this.next();
      }

      onClose() {
        clearTimeout(this.timer);
        this.timer = null;
        this.paused = false;
        document.documentElement.style.overflow = '';
        this.trigger?.focus({ preventScroll: true });
      }
    }
    customElements.define('dp24-story-bar', Dp24StoryBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dp24-tracking"]) return;
  try {
    
  if (!customElements.get('dp24-order-tracking')) {
    class Dp24OrderTracking extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[data-track-form]');
        this.input = this.querySelector('[data-track-input]');
        this.msg = this.querySelector('[data-track-msg]');
        this.result = this.querySelector('[data-track-result]');
        const fromUrl = new URLSearchParams(location.search).get('tracking');
        if (fromUrl) this.input.value = fromUrl;
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.track();
        });
        if (fromUrl) this.track();
      }

      loadWidget() {
        if (window.YQV5) return Promise.resolve();
        if (this.loading) return this.loading;
        this.loading = new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.src = 'https://www.17track.net/externalcall.js';
          s.onload = resolve;
          s.onerror = reject;
          document.head.append(s);
        });
        return this.loading;
      }

      async track() {
        const num = this.input.value.replace(/\s+/g, '').trim();
        this.msg.hidden = !!num;
        if (!num) {
          this.input.focus();
          return;
        }
        this.result.hidden = false;
        try {
          await this.loadWidget();
          window.YQV5.trackSingle({ YQ_ContainerId: this.result.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: num });
          this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener');
          this.result.hidden = true;
        }
      }
    }
    customElements.define('dp24-order-tracking', Dp24OrderTracking);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* DP24 2026-10-30: "Show 24 more designs" (snippets/pagination-controls.liquid). The button is a
     plain link to ?page=n; here the next page is fetched with the Section Rendering API, its cards
     are appended and the button is replaced by the next page's one. Any failure falls back to
     following the link. Delegated, so it keeps working after the filters re-render the grid.
     Review 2026-10-30 #33: the URL stays as it is. The progress (last loaded page) and the scroll
     position live in history.state, so reload or Back without bfcache loads the same pages again
     and returns to the same spot. A fetched page with no new cards (all sold out and hidden)
     follows that page's own "more" link instead of navigating away.
     Review 2 (2026-10-30) #33: from 990px Horizon scrolls inside .page-wrapper, not the window
     (assets/scroll-container.js), so save and restore use the real scroll container. The restore
     runs only on reload / Back-Forward, never on a normal visit. */
  const dp24PageOf = (href) => Number(new URL(href, window.location.href).searchParams.get('page')) || 1;

  /* Same rule as Horizon's getScrollContainer() (a classic script cannot import @theme/scroll-container) */
  const dp24Sc = () =>
    (window.matchMedia('(min-width: 990px)').matches && document.querySelector('.page-wrapper')) ||
    document.scrollingElement ||
    document.documentElement;

  const dp24Save = (extra) => {
    try {
      history.replaceState({ ...(history.state || {}), dp24Url: window.location.href, ...extra }, '');
    } catch (e) {}
  };

  /* Appends the page behind link (skipping up to 5 empty pages); returns the new cards */
  const dp24LoadMore = async (link) => {
    const list = link.closest('results-list');
    const grid = list?.querySelector('.product-grid');
    const sectionId = list?.getAttribute('section-id');
    if (!grid || !sectionId) return null;
    let target = new URL(link.href, window.location.href);
    let doc = null;
    let items = [];
    for (let hop = 0; hop < 6; hop++) {
      const fetchUrl = new URL(target);
      fetchUrl.searchParams.set('section_id', sectionId);
      const response = await fetch(fetchUrl, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(String(response.status));
      doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      items = [...doc.querySelectorAll('.product-grid > .product-grid__item')].filter(
        (item) => !item.id || !document.getElementById(item.id)
      );
      if (items.length) break;
      const next = doc.querySelector('.dp24-more [data-dp24-more]');
      if (!next) break;
      target = new URL(next.getAttribute('href'), window.location.href);
    }
    const added = items.map((item) => document.importNode(item, true));
    if (added.length) grid.append(...added);
    const nav = link.closest('.dp24-more');
    const nextNav = doc && doc.querySelector('.dp24-more');
    nextNav?.querySelector('.dp24-more__prev')?.remove();
    if (nav && nextNav?.querySelector('[data-dp24-more]')) {
      nav.replaceWith(document.importNode(nextNav, true));
    } else {
      nav?.remove();
    }
    dp24Save({ dp24LoadedThrough: dp24PageOf(target.href) });
    return added;
  };

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    /* Remember the scroll position before leaving for a product (Back without bfcache) */
    const card = event.target.closest('.product-grid a[href]');
    if (card) {
      dp24Save({ dp24ScrollY: dp24Sc().scrollTop });
      return;
    }
    const link = event.target.closest('a[data-dp24-more]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!link.closest('results-list')?.querySelector('.product-grid')) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    try {
      const added = await dp24LoadMore(link);
      if (added === null) throw new Error('no grid');
      /* Keyboard and screen reader users continue at the first new design (no aria-live) */
      added[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
    } catch (error) {
      window.location.href = link.href;
    }
  });

  window.addEventListener('pagehide', () => {
    if (history.state?.dp24LoadedThrough) dp24Save({ dp24ScrollY: dp24Sc().scrollTop });
  });

  /* Reload / Back without bfcache: load the pages that were shown before, then restore the scroll */
  (async () => {
    const state = history.state;
    if (!state || !state.dp24LoadedThrough || state.dp24Url !== window.location.href) return;
    const navType = (performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null)?.type;
    if (navType && navType !== 'reload' && navType !== 'back_forward') return;
    const ready = document.readyState === 'loading' ? new Promise((r) => document.addEventListener('DOMContentLoaded', r, { once: true })) : Promise.resolve();
    await ready;
    let current = dp24PageOf(window.location.href);
    try {
      while (current < state.dp24LoadedThrough) {
        const link = document.querySelector('results-list a[data-dp24-more]');
        if (!link) break;
        link.setAttribute('aria-busy', 'true');
        const added = await dp24LoadMore(link);
        if (!added || !added.length) break;
        current = history.state?.dp24LoadedThrough || state.dp24LoadedThrough;
      }
    } catch (e) {}
    /* After the pages are appended and after Horizon's own (clamped) pageshow restore;
       'instant' because html and .page-wrapper have scroll-behavior: smooth */
    const y = typeof state.dp24ScrollY === 'number' ? state.dp24ScrollY : state.scrollTop;
    if (typeof y === 'number') requestAnimationFrame(() => dp24Sc().scrollTo({ top: y, behavior: 'instant' }));
  })();

  } catch(e) { console.error(e); }
})();
})();
